<template>
<div>
  <transition name="slide-up">
    <div v-if="showNotify">
      <div v-if="hasPendingInstallments" :class="{
        'animate-pulse': loadings.inscriptionPayment
      }" class="py-2 pb-3 flex-wrap gap-2 flex items-center px-4 shadow-lg justify-between bg-gray-900 fixed left-4 right-8 bg-opacity-80 backdrop-filter backdrop-blur-lg rounded-xl bottom-4 z-10">
        <div class="w-full text-right text-white">
          <p class="block ml-auto cursor-pointer w-4" @click="showNotify = false">X</p>
        </div>
        <div class="flex flex-col">
          <h1 class="text-lg text-white text-center md:text-left">
            <template v-if="!isAdmin">
              {{ user.student.gender === 'female' ? 'Bienvenida' : 'Bienvenido'}}, {{ user.student.first_name }} {{ user.student.last_name }}. tienes {{ missingInstallments }} {{ missingInstallments === 1 ? 'cuota pendiente' : 'cuotas pendientes' }}.
            </template>
            <template v-else>
              Este estudiante tiene {{ missingInstallments }} {{ missingInstallments === 1 ? 'cuota pendiente' : 'cuotas pendientes' }}.
            </template>
          </h1>
          <h2 class="text-gray-200 text-center md:text-left">
            Costo de la siguiente cuota: ${{ missingPaymentAmount / 100 }}
          </h2>
          <template v-if="installmentIsLate">
            <h2 class="text-red-500 text-center md:text-left">
              La siguiente cuota está atrasada, por lo que se le cobrara un extra de ${{ periodFee.late_installment_extra / 100 }}
            </h2>
          </template>
          <template v-else-if="daysUntilLateFee.isAfter">
            <h2 class="text-red-500 text-center md:text-left">
              Te quedan {{ daysUntilLateFee.days }} días para pagar o tendrás que abonar ${{ periodFee.late_installment_extra / 100 }} extra
            </h2>
          </template>
          <template v-if="lastPaymentRejected">
            <h2 class="text-red-500 text-center md:text-left">
              El último pago fue rechazado
            </h2>
          </template>
        </div>

        <div class="space-x-2">
          <a-button class="w-full md:w-auto" :disabled="loadings.sendingPayment" @click="modals.inscriptionPayment = true">
            Reportar pago
          </a-button>

          <a-button class="w-full md:w-auto" :disabled="loadings.sendingPayment" @click="verifyInscription">
            Refrescar
          </a-button>
        </div>
      </div>
    </div>
  </transition>

  <a-modal
    :show="modals.inscriptionPayment"
    :confirm-text="paymentStep === 1 ? 'Siguiente' : 'Reportar pago'"
    :cancel-text="paymentStep === 1 ? 'Cancelar' : 'Anterior'"
    :title="paymentStep === 1 ? 'Datos de pago' : 'Resumen de pago'"
    :disabled-confirm="shouldConfirmButtonDisabled()"
    @confirm="paymentStep === 1 ? handleNextStep() : pay()"
    @cancel="handleCancel()">
    <template v-if="paymentStep === 1">
      <div class="space-y-4">
        <div class="flex w-full">
          <label class="font-medium block">
            Forma de pago
          </label>
          <span class="text-red-600 inline-block ml-1 font-bold">
            *
          </span>
        </div>
        <div class="flex flex-row space-x-4 w-full my-2">
          <label class="inline-flex items-center">
            <input type="radio" 
              id="installment" 
              value="installment"
              v-model="paymentOption"
              class="form-radio h-4 w-4 text-blue-600">
            <span class="ml-2">Pagar por cuota</span>
          </label>
          <label class="inline-flex items-center">
            <input type="radio" 
              id="fully" 
              value="fully"
              v-model="paymentOption"
              class="form-radio h-4 w-4 text-blue-600">
            <span class="ml-2">Pagar por completo</span>
          </label>
        </div>
        <template v-if="paymentOption === 'installment'">
          <div class=" bg-gray-200 p-3 rounded my-2">
            <div class="flex items-center justify-between my-2">
              <span>Costo de la siguiente cuota:</span> 
              <b>
                ${{ missingPaymentAmount / 100 }}
              </b>
            </div>
          </div>
        </template>
        <template v-else>
          <div class=" bg-gray-200 p-3 rounded my-2">
            <div class="max-h-32 overflow-y-auto">
              <template
                v-for="(installment, index) in getUnpaidFeeInstallments(periodFee.fee_installments)"
              >
                <div :key="index" class="flex items-center justify-between my-2">
                  <span>Costo {{ index + 1 }}° cuota:</span> 
                  <b>
                    ${{ getMissingInstallmentsTotal(installment) / 100 }}
                  </b>
                </div>
              </template>
            </div>
            <hr class="my-2 h-px border-t-0 bg-gray-500" />
            <div class="flex items-center justify-between my-2">
              <span>Costo total:</span> 
              <b>
                ${{ missingTotalPaymentAmount / 100 }}
              </b>
            </div>
          </div>
        </template>
        <a-select
            :source="getPaymentMethods"
            label="Tipo de pago"
            required
            class="mb-4"
            :error="error('type', { attribute: 'tipo de pago' })"
            v-model="form.type"/>
  
        <a-input
          label="Fecha"
          class="mb-4"
          required
          id="date"
          type="date"
          :error="error('date')"
          v-model="form.date" />
  
        <a-input
          label="Monto"
          :required="paymentOption === 'installment'"
          :disabled="paymentOption === 'fully'"
          class="mb-4"
          id="amount"
          type="number"
          :error="error('amount')"
          v-model.number="form.amount" />

          <a-input
          :required="form.type !== '1'"
          :disabled="form.type === '1'"
          label="Número de recibo"
          class="mb-4"
          id="receipt_number"
          :error="error('receipt_number')"
          v-model="form.receipt_number" />
      </div>
    </template>
    <template v-else-if="paymentStep === 2">
      <div class="space-y-4">
        <div class="flex flex-col gap-4 max-h-80 overflow-y-auto">
          <div
            v-for="(installment, index) in periodFee.fee_installments"
            :key="index"
            :class="[
              'rounded-lg p-5 border-solid content-center h-24 bg-white border-l-4',
              installment.paid_amount_e2 < installment.amount_e2 
                ? isEnabled(installment.id)
                  ? 'border-red-400 shadow-lg'
                  : 'bg-gray-100 border-gray-30'
                : 'border-primary shadow-lg bg-gray-100'
            ]"
          >
            <div class="flex justify-between items-center">
              <div class="flex flex-col gap-1">
                <div class="flex items-center gap-2">
                  <a-icon name="calendar" />
                  <span class="text-gray-700 font-medium">
                    {{ moment(installment.date).locale('es').format('D [de] MMMM') }}
                  </span>
                </div>
                <template v-if="installment.is_late">
                  <span class="text-red-500 text-xs">
                    La cuota está atrasada, por lo que se le cobrará un extra de {{ installment.late_extra_amount_string }}
                  </span>
                </template>
                <template v-else-if="getDaysUntilLateFee(installment).isAfter">
                  <span class="text-yellow-400 text-xs">
                    Te quedan {{ getDaysUntilLateFee(installment).days }} días para pagar o tendrás que abonar {{ installment.late_extra_amount_string }} extra
                  </span>
                </template>
              </div>
              <div class="flex flex-col items-end gap-2 relative">
                <div class="flex items-center gap-2">
                  <template v-if="selectedInstallments[index] && selectedInstallments[index].paid_amount_e2 >= selectedInstallments[index].amount_e2">
                    <div class="rounded-full border-2 border-primary w-6 h-6 flex items-center justify-center bg-primary">
                      <a-icon name="check" class="text-white" stroke-width="2" />
                    </div>
                  </template>
                  <template v-else-if="selectedInstallments[index] && selectedInstallments[index].paid_amount_e2 > 0">
                    <div class="rounded-full border-2 border-yellow-400 bg-yellow-400 w-6 h-6 flex items-center justify-center">
                      <a-icon name="minus" class="text-white" stroke-width="2" />
                    </div>
                  </template>
                  <span class="text-gray-700 font-medium">
                    {{ getInstallmentAmount(index) }}
                  </span>
                </div>
                <div 
                  v-if="selectedInstallments[index]" 
                  class="text-xs w-full flex flex-col gap-1" 
                >
                  <template v-if="selectedInstallments[index].is_new">
                    <div class="flex items-center justify-between w-40">
                      <span class="font-bold">Monto abonado:</span> 
                      <span>{{ (selectedInstallments[index].paid_amount_e2 / 100) }}$</span>
                    </div>
                    <template v-if="selectedInstallments[index].paid_amount_e2 < selectedInstallments[index].amount_e2">
                      <div class="flex items-center justify-between w-40">
                        <span class="font-bold text-red-500">Restante:</span> 
                        <span>{{ (selectedInstallments[index].amount_e2 - selectedInstallments[index].paid_amount_e2) / 100 }}$</span>
                      </div>
                    </template>
                  </template>
                  <template v-else-if="selectedInstallments[index].paid_amount_e2 >= selectedInstallments[index].amount_e2">
                    <a-badge class="bg-primary text-white">
                      Aprobado
                    </a-badge>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </a-modal>
</div>
</template>

<script>
import Vue from 'vue';
import {mapActions, mapGetters, mapState} from "vuex";
import moment from 'moment';

export default {
  props: {
    inscription: { required: true, type: Object },
    isAdmin: { required: false, type: Boolean, default: false },
    periodFee: { required: false, type: Object, default: () => ({}) },
  },
  data: () => ({
    form: {
      type: "",
      date: "",
      amount: "",
      receipt_number: ""
    },
    showNotify: true,
    modals: {
      inscriptionPayment: false
    },
    loadings: {
      inscriptionPayment: false,
      sendingPayment: false
    },
    paymentOption: "installment",
    shouldDisplayInscriptionPayment: false,
    paymentMethods: [
      { label: 'Efectivo', value: "1" },
      { label: '100% Banco', value: "2" },
      { label: 'Transferencia Bancaria', value: "3" },
      { label: 'Transferencia de Curso', value: "4" },
      { label: 'Zelle', value: "5" },
    ],
    paymentStep: 1,
    selectedInstallments: []
  }),
  computed: {
    ...mapGetters({
      error: 'error'
    }),
    ...mapState({
      user: ({ session }) => session.user,
      studentData: state => state.students.current
    }),
    isPartialPaid () {
      return this.inscription?.partial_paid ?? false
    },
    hasPendingInstallments () {
      if(this.periodFee?.period_id && this.studentData){
        if(!this.periodFee.completed_at){
          const latestInscription = this.studentData.latest_inscription;
          const lastPaymentStatus = this.periodFee.payments.length > 0 ?
            this.periodFee.payments[this.periodFee.payments.length - 1].status : 1;
          const isSamePeriodAsInscription =  this.periodFee.period_id === latestInscription.period_id;
          const fiteredPayments = this.periodFee.payments.filter(payment => payment.status === 2);
          if(isSamePeriodAsInscription && (fiteredPayments.length > 0) && (lastPaymentStatus === 2 || lastPaymentStatus === 3)){
            const getUnpaidFeeInstallments = this.getUnpaidFeeInstallments(this.periodFee.fee_installments);
            const today = moment();
            const installmentDate = moment(getUnpaidFeeInstallments[0].date);
            const diffInDays = installmentDate.diff(today, 'days');
            const isWithinFiveDaysOrPast = diffInDays <= 5;
            if(process.env.VUE_APP_NODE_ENV.toLowerCase() === 'production'){
              return isWithinFiveDaysOrPast;
            } return true;
          } return false;
        } return false;
      } return false;
    },
    getPaymentMethods () {
      if(this.periodFee?.installment_payment_methods || this.periodFee?.full_payment_methods){
        if(this.paymentOption === "installment"){
          return this.paymentMethods.filter($0 => this.periodFee.installment_payment_methods.includes($0.value)) ?? [];
        }
        return this.paymentMethods.filter($0 => this.periodFee.full_payment_methods.includes($0.value)) ?? [];
      } return [];
    },
    missingInstallments () {
      if(this.periodFee?.fee_installments){
        return this.periodFee.fee_installments
          .filter(installment => installment.paid_amount_e2 < installment.amount_e2)
          .length;
      } return 0;
    },
    installmentIsLate () {
      if(this.periodFee?.fee_installments){
        const filteredUnpaidInstallemnts = this.periodFee.fee_installments
          .filter(installment => installment.paid_amount_e2 < installment.amount_e2);
        if(filteredUnpaidInstallemnts.length > 0){
          const nextInstallment = filteredUnpaidInstallemnts[0];
          return nextInstallment.is_late;
        } return false;
      } return false;
    },
    lastPaymentRejected () {
      if(this.periodFee?.payments && this.periodFee.payments.length > 0){
        const lastPayment = this.periodFee.payments[this.periodFee.payments.length - 1];
        return lastPayment.status === 3;
      } return false;
    },
    daysUntilLateFee() {
      if (this.periodFee?.fee_installments) {
        const filteredUnpaidInstallments = this.periodFee.fee_installments
          .filter(installment => installment.paid_amount_e2 < installment.amount_e2);
        if (filteredUnpaidInstallments.length > 0) {
          const nextInstallment = filteredUnpaidInstallments[0];
          const today = moment().startOf('day');
          const installmentDate = moment(nextInstallment.date).startOf('day');
          const diffInDays = installmentDate.diff(today, 'days');
          const dueDateWithGrace = installmentDate.clone().add(this.periodFee.installment_grace_period_days, 'days');
          const daysLeft = dueDateWithGrace.diff(today, 'days');
          const isSameDay = installmentDate.isSame(today, 'day');
          return {
            isAfter: isSameDay ? false : diffInDays <= 0,
            days: daysLeft
          };
        }
      }
      return {
        isAfter: false,
        days: 0
      };
    },
    missingPaymentAmount() {
      if(this.periodFee?.fee_installments){
        const filteredUnpaidInstallemnts = this.periodFee.fee_installments
          .filter(installment => installment.paid_amount_e2 < installment.amount_e2);

        if(filteredUnpaidInstallemnts.length > 0){
          const nextInstallment = filteredUnpaidInstallemnts[0];
          const amountPaid = nextInstallment.paid_amount_e2;
          const amountToPay = nextInstallment.is_late 
            ? nextInstallment.amount_e2 + nextInstallment.late_extra_amount_e2 - amountPaid 
            : nextInstallment.amount_e2 - amountPaid;
          return amountToPay;
        }
      } return 0;
    },
    missingTotalPaymentAmount () {
      if(this.periodFee?.fee_installments){
        const reducedTotalAmount = this.periodFee.fee_installments
          .filter(installment => installment.paid_amount_e2 < installment.amount_e2)
          .reduce((acc, installment) => {
            const amountPaid = installment.paid_amount_e2;
            const amountToPay = installment.is_late 
              ? installment.amount_e2 + installment.late_extra_amount_e2 - amountPaid 
              : installment.amount_e2 - amountPaid;
            acc += amountToPay;
            return acc;
          }, 0);
        return reducedTotalAmount;
      } return 0;
    }
  },
  methods: {
    ...mapActions({
      configure: 'session/configure',
      reportPayment: 'payments/store',
    }),
    handleCancel () {
      this.modals.inscriptionPayment = false;
      this.paymentStep = 1;
      this.selectedInstallments = [];
      this.paymentOption = "installment";
      Object.keys(this.form).forEach(key => this.form[key] = "");
    },
    getMissingInstallmentsTotal (installment) {
      const amountPaid = installment.paid_amount_e2;
      const amountToPay = installment.is_late 
        ? installment.amount_e2 + installment.late_extra_amount_e2 - amountPaid 
        : installment.amount_e2 - amountPaid;
      return amountToPay;
    },
    getUnpaidFeeInstallments (installments) {
      return installments.filter(installment => installment.paid_amount_e2 < installment.amount_e2);
    },
    getDaysUntilLateFee(installment) {
      if (installment) {
        const today = moment().startOf('day');
        const installmentDate = moment(installment.date).startOf('day');
        const diffInDays = installmentDate.diff(today, 'days');
        const dueDateWithGrace = installmentDate.clone().add(this.periodFee.installment_grace_period_days, 'days');
        const daysLeft = dueDateWithGrace.diff(today, 'days');
        const isSameDay = installmentDate.isSame(today, 'day');
        return {
          isAfter: isSameDay ? false : diffInDays <= 0,
          days: daysLeft
        };
      } return {
        isAfter: false,
        days: 0
      };
    },
    handleNextStep () {
      const filteredInstallments = this.periodFee.fee_installments.filter(installment => installment.paid_amount_e2 >= installment.amount_e2);
      this.selectedInstallments = filteredInstallments;
      
      if(this.paymentOption === "installment"){
        let totalAmount = this.form.amount * 100;
        this.periodFee.fee_installments
          .filter(instalment => instalment.paid_amount_e2 < instalment.amount_e2)
          .forEach(installment => {
            const amountPaid = installment.paid_amount_e2;
            const amountToPay = installment.is_late
              ? installment.amount_e2 + installment.late_extra_amount_e2 - amountPaid 
              : installment.amount_e2 - amountPaid;
              if (amountToPay > 0 && totalAmount > 0) {
                const totalToPay = Math.min(totalAmount, amountToPay);
                totalAmount = Math.max(0, totalAmount - totalToPay);
                this.selectedInstallments.push({
                  ...installment,
                  amount_e2: amountToPay,
                  is_new: true,
                  paid_amount_e2: totalToPay
                });
              }
          });
      }
      else {
        this.periodFee.fee_installments
          .filter(installment => installment.paid_amount_e2 < installment.amount_e2)
          .forEach(installment => {
            const amountPaid = installment.paid_amount_e2;
            const amountToPay = installment.is_late
              ? installment.amount_e2 + installment.late_extra_amount_e2 - amountPaid 
              : installment.amount_e2 - amountPaid;
            this.selectedInstallments.push(
              {
                ...installment,
                amount_e2: amountToPay,
                is_new: true,
                paid_amount_e2: amountToPay
              }
            );
          });
      }
      this.paymentStep++
    },
    getInstallmentAmount(index){
      if(this.selectedInstallments[index]){
        return `${this.selectedInstallments[index].amount_e2 / 100}$`;
      }
      return this.periodFee.fee_installments[index].amount_string;
    },
    moment,
    shouldConfirmButtonDisabled () {
      if(this.loadings.sendingPayment) return true;
      if(this.paymentStep === 1){
        const keys = ['type', 'date'];
        if(this.form.type !== "1"){
          keys.push('receipt_number');
        }
        if(this.paymentOption === "installment"){
          keys.push('amount');
        }
        return keys.some($0 => !this.form[$0] || this.form[$0] === null || this.form[$0] === '');
      }
      if(this.paymentStep === 2){
        return this.selectedInstallments.length === 0;
      }
      return false;
    },
    verifyInscription() {
      this.$emit('check');
    },
    pay() {
      Vue.prototype.$confirm({
        message: `¿Desea reportar el pago? Esta acción no se puede deshacer`,
        button: {
            no: 'No',
            yes: 'Si'
        },
        callback: confirm => {
          if (confirm) {
            this.loadings.sendingPayment = !this.loadings.sendingPayment;
            this.reportPayment({
                ...this.form,
                student_id: this.inscription.student_id,
                type: Number(this.form.type),
                receipt_number: this.form.type !== "1" ? this.form.receipt_number : null,
                amount: this.paymentOption === "installment" 
                  ? (this.form.amount ?? 0) * 100
                  : this.missingTotalPaymentAmount,
                period_id: this.periodFee.period_id,
                from_report: true
              })
              .then(() => {
                this.loadings.sendingPayment = !this.loadings.sendingPayment;
                this.modals.inscriptionPayment = false;
                this.form = {
                  type: "",
                  date: "",
                  amount: "",
                  receipt_number: ""
                }
                this.paymentStep = 1;
                this.selectedInstallments = [];
                this.paymentOption = "installment";
                this.verifyInscription()
              })
              .catch(() => {
                this.loadings.sendingPayment = !this.loadings.sendingPayment;
              });
          }
        }
      })
    },
    isEnabled(id) {
      const find = this.selectedInstallments.find(installment => installment.id === id);
      return find ? true : false;
    }
  },
  watch: {
    paymentOption (val) {
      if(val){
        this.form.type = "";
        this.form.amount = "";
        document.getElementById('amount').value = "";
      }
    }
  }
}
</script>

<style>
.slide-up-enter-active, .slide-up-leave-active {
  transition: all .5s;
}

.slide-up-enter, .slide-up-leave-to {
  opacity: 0;
  transform: translateY(100px);
}
</style>
